import React from 'react';

import { useHistory } from 'react-router-dom';

import useConfiguratorData from '../../hooks/useConfiguratorData';
import useLinksData from '../../hooks/useLinksData';

const VersionSelector = () => {

    const { getSelectedModel, getSelectedVersion } = useConfiguratorData();
    const { getLinks } = useLinksData();

    const selectedVersion = getSelectedVersion();
    const selectedModel = getSelectedModel();

    const links = getLinks();

    const history = useHistory();

    const handleVersionChange = (version) => {
        history.push(`/configurar/${version.id}`);
    }

    return (
        <div className="version-selector">
            <div className="component-header">
                <h2>Elige una versión</h2>
                <a href={links.compare_page ? `${links.compare_page}?model_id=${selectedModel.id}` : '#'} target="_modal" className="link-arrow">Comparar versiones<i className="icon chevron-strong"></i></a>
            </div>
            <div className="component-body">
                {selectedModel.versions.filter(version => !version.stock_warning).map(version => (
                    <div className={"item-box " + (selectedVersion.id === version.id ? 'active' : '')} key={`version-${version.id}`} onClick={() => handleVersionChange(version)}>
                        <span>{version.name}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default VersionSelector;